"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = VineSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function VineSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Vine"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "vine-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.429,92.5H18.571A11.084,11.084,0,0,1,7.5,81.429V18.571A11.084,11.084,0,0,1,18.571,7.5H81.429A11.084,11.084,0,0,1,92.5,18.571V81.429A11.084,11.084,0,0,1,81.429,92.5Zm-62.858-80A6.079,6.079,0,0,0,12.5,18.571V81.429A6.079,6.079,0,0,0,18.571,87.5H81.429A6.079,6.079,0,0,0,87.5,81.429V18.571A6.079,6.079,0,0,0,81.429,12.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M68.4,49.875v4.993a23.121,23.121,0,0,1-4.993.585c-3.537,7.418-9.872,13.782-11.991,14.971a3.717,3.717,0,0,1-4.092-.077c-2.6-1.562-12.45-9.642-15.728-35.04h7.14c1.793,15.248,6.182,23.069,11,28.925a39.8,39.8,0,0,0,7.246-10.246c-4.773-2.424-7.677-7.753-7.677-13.954C49.31,33.744,52.923,29,59.105,29c11.013,0,10.179,12.258,7.821,17.4,0,0-4.447.881-6.086-1.965a17.432,17.432,0,0,0,.786-4.649c0-3-1.083-4.466-2.722-4.466-1.744,0-2.952,1.639-2.952,4.792.009,7.591,5.693,11.377,12.45,9.767Z"
  })))));
}